import { useUser } from '@resistapp/client/contexts/use-user-context';
import { getUserProjectIds } from '@resistapp/common/access';
import { isAdmin } from '@resistapp/common/features';
import { OrganisationUserRole } from '@resistapp/common/types';
import { Navigate } from 'react-router-dom';
import { LoadingView } from '../components/states/loading';
import { getPreferredProjectId, shouldForceLabLanding } from '../utils/access';
import { useLabWorkbookLanding } from '../hooks/use-lab-workbook-landing';
import { getBestPageForProject } from '../utils/project-page-access';
import { WorldView } from './world-view/world-view';

export function LanderView() {
  const { user, userLoading } = useUser();
  const forceLabLanding = shouldForceLabLanding(user);
  const {
    path: labLandingPath,
    organisationId: labLandingOrganisationId,
    ensureQuery: labLandingQuery,
  } = useLabWorkbookLanding(user, { enabled: forceLabLanding });
  const labLandingPending = Boolean(forceLabLanding && labLandingOrganisationId && labLandingQuery.isPending);

  if (userLoading || labLandingPending) {
    return <LoadingView />;
  } else if (!user) {
    return <WorldView />;
  }

  const projectIds = getUserProjectIds(user);
  const preferredProjectId = getPreferredProjectId(user);
  const hasProjects = projectIds.length > 0;
  const hasOrganisationAdminRole = user.organisations.some(org => org.membershipRole === OrganisationUserRole.ADMIN);
  if (forceLabLanding && labLandingPath) {
    return <Navigate to={labLandingPath} replace />;
  }

  if (forceLabLanding) {
    return <Navigate to="/admin/lab-workbooks" replace />;
  }

  if (isAdmin(user) || hasOrganisationAdminRole) {
    return <Navigate to={`/admin`} replace />;
  }

  if (hasProjects && preferredProjectId != null) {
    return <Navigate to={`/${getBestPageForProject(user, preferredProjectId)}/${preferredProjectId}`} replace />;
  }

  return <WorldView />;
}
